export default __webpack_public_path__ + "static/media/K0005.f874b8fc.png";